module.exports = __webpack_public_path__ + "img/back.e00f3065.png";